export enum InputType {
  text,
  dropdown,
}
